import { BAZAARVOICE_SCRIPT_URLS } from './constants'
import { getRatingThreshold } from './getRatingThreshold'
import type { RatingEnvironment, RatingEnvironmentConfig } from './types'

const VALID_ENVIRONMENTS: readonly RatingEnvironment[] = [
  'local',
  'development',
  'preproduction',
  'production',
]

function isRatingEnvironment(value: string | undefined): value is RatingEnvironment {
  return VALID_ENVIRONMENTS.includes(value as RatingEnvironment)
}

/**
 * Lee `RATING_APP_ENV` (server-only) y devuelve la configuración resuelta para
 * el entorno actual. `NODE_ENV` no sirve como discriminador aquí: `next build`
 * lo fuerza a `production` por igual en development/preproduction/production
 * desplegados (research.md R2) — se necesita esta variable dedicada.
 *
 * Valor ausente o no reconocido ⇒ `'local'` (mismo default que el `ARG` del
 * Dockerfile): un despliegue real sin la variable configurada cae al umbral
 * más permisivo en vez de romper el render, pero queda documentado como una
 * configuración pendiente de completar (research.md R2, T003).
 */
export function getRatingEnvironment(): RatingEnvironmentConfig {
  const raw = process.env.RATING_APP_ENV
  const environment: RatingEnvironment = isRatingEnvironment(raw) ? raw : 'local'

  return {
    environment,
    bazaarvoiceScriptUrl: BAZAARVOICE_SCRIPT_URLS[environment],
    minRatingsThreshold: getRatingThreshold(environment),
  }
}
